export default "__VITE_ASSET__7764133f__"